import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        'bg-accent animate-pulse rounded-md transition-opacity duration-300 ease-in-out',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
